import { ArrowRight, BookOpen } from 'lucide-react'

const CarteCategorie = ({ category, onClick }) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 flex flex-col h-full group">
      <div className="relative h-56 overflow-hidden">
        <img 
          src={category.image || 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800'} 
          alt={category.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6">
           <div className="text-white">
              <span className="bg-cidh-gold text-black text-[10px] font-bold px-2 py-0.5 rounded uppercase mb-2 inline-block">
                DOMAINE D'EXPERTISE
              </span>
              <h3 className="text-xl font-bold font-montserrat tracking-tight leading-tight">
                {category.name}
              </h3>
           </div>
        </div>
      </div>
      
      <div className="p-6 flex-grow flex flex-col">
        <p className="text-gray-600 text-sm mb-6 line-clamp-3 leading-relaxed">
          {category.description}
        </p>
        
        <button 
          onClick={() => onClick(category.name)}
          className="mt-auto w-full py-3 bg-white border-2 border-cidh-blue text-cidh-blue font-bold rounded-lg hover:bg-cidh-blue hover:text-white transition-all flex items-center justify-center gap-2 group-hover:shadow-lg"
        >
          Voir nos formations <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  )
}

export default CarteCategorie
